import envVar from '../config/envVars';
import {
  AcademicYearTermsRequestBody,
  GetAYTermsRequestBody
} from '../modules/AcademicTerms/types';
import httpPost from './httpClient/httpPost';

const getAYTerms = async (school: string, payload?: GetAYTermsRequestBody) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/terms`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const upsertAYTerms = async (
  school: string,
  payload: AcademicYearTermsRequestBody
) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/academic-year-terms`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const academicTermsApis = {
  getAYTerms,
  upsertAYTerms
};

export default academicTermsApis;
